/* eslint-disable react/prop-types */
import { Cancel } from "@mui/icons-material";
import ArticleIcon from "@mui/icons-material/Article";
import BusinessIcon from "@mui/icons-material/Business";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";
import {
  Alert,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Snackbar,
  Tab,
  Tabs,
  useMediaQuery,
} from "@mui/material";
import theme from "assets/theme";
import AddListFile from "components/AddListFile";
import CustomTabPanel from "components/CustomPanel/customPanel";
import { useEffect, useMemo, useRef, useState } from "react";
import { JsonTool } from "utils/jsonTools";
import CustomFieldForm from "../../components/CustomFieldForm";
import {
  PaperComponent,
  validateArrayFileRequired,
} from "../../utils/constants";
import { useRecoilValue } from "recoil";
import { SettingState } from "states";

const defaultValue = {
  ma: "",
  ten: "",
  chuthe: "",
  hang: 1,
  quymo: "",
  quycach: "",
  tieuchuan: "",
  nhomsanpham: "",
  trangthaisanpham: 1,
  ghichu: "",
};

const FormSanPham = ({
  data,
  open,
  onClose,
  onSubmit,
  title,
  validationErrors,
  action,
  dataHuyen,
  dataNhomSanPham,
  dataChuThe,
  isOwner,
}) => {
  // state lỗi giá trị từ form
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const formRef = useRef(null);
  const [errors, setErrors] = useState();
  const [dataState, setDataState] = useState(defaultValue);
  const [value, setValue] = useState(0);
  const [alert, setAlert] = useState({
    alert: false,
    message: null,
    type: null,
  });
  const settingState = useRecoilValue(SettingState);
  const [dungluong, setDungluong] = useState(0);
  //state file
  const [fileDel, setFileDel] = useState([]);
  const [fileFields, setFileFields] = useState([]);
  const [fileEditName, setFileEditName] = useState({});

  const fieldInfor = useMemo(() => {
    let result = [
      {
        name: "Chủ thể",
        key: "chuthe",
        type: "autocomplete",
        unicode: "id",
        required: true,
        hasPlaceholder: true,
        labelKeyOption: "ten",
        isHidden: isOwner,
        xs: 12,
        md: 12,
        lg: 12,
      },
      {
        name: "Nhóm sản phẩm",
        key: "nhomsanpham",
        type: "select",
        unicode: "id",
        required: true,
        hasPlaceholder: true,
        labelKeyOption: "ten",
        xs: 12,
        md: 12,
        lg: 12,
      },
      {
        name: "Tên sản phẩm",
        key: "ten",
        type: "text",
        required: true,
        maxLength: 255,
        xs: 12,
        md: 12,
        lg: 12,
      },
      {
        name: "Quy cách",
        key: "quycach",
        type: "textArea",
        maxLength: 255,
        xs: 12,
        md: 6,
        lg: 6,
      },
      {
        name: "Tiêu chuẩn",
        key: "tieuchuan",
        type: "textArea",
        maxLength: 255,
        xs: 12,
        md: 6,
        lg: 6,
      },
      {
        name: "Quy mô",
        key: "quymo",
        type: "textArea",
        maxLength: 255,
        xs: 12,
        md: 6,
        lg: 6,
      },
      {
        name: "Hạng",
        key: "hang",
        type: "select",
        unicode: "id",
        required: true,
        hasPlaceholder: true,
        labelKeyOption: "ten",
        xs: 12,
        md: 3,
        lg: 3,
      },
      {
        name: "Trạng thái",
        key: "trangthaisanpham",
        type: "select",
        unicode: "id",
        required: true,
        hasPlaceholder: true,
        labelKeyOption: "ten",
        xs: 12,
        md: 3,
        lg: 3,
      },
      {
        name: "Ghi chú",
        key: "ghichu",
        type: "textArea",
        maxLength: 255,
        xs: 12,
        md: 12,
        lg: 12,
      },
    ];
    return result;
  }, []);

  useEffect(() => {
    if (data?.id) {
      setDataState(data);
    } else {
      setDataState(defaultValue);
    }
    setDungluong(settingState["dungluong_file_upload"]);
  }, [data]);

  async function onSubmitForm(event) {
    event.preventDefault();
    const _data = { ...dataState };
    if (action == "Edit") {
      delete _data["tepdinhkem_sanpham"];
      _data["fileDel"] = fileDel;
      _data["id"] = data?.id;
    }
    if (isOwner) {
      _data["chuthe"] = dataChuThe[0]["id"];
    }
    _data["tentepdinhkem"] = fileFields?.map((item) => item?.filename) || [];
    _data["tepdinhkemValidate"] = fileFields?.map((item) => item?.file) || [];
    _data["tentepdinhkemEdit"] = Object.values(fileEditName);
    const newValidationErrors = validateOBJ(_data, isOwner, dungluong);
    let _tempValid = newValidationErrors;
    if (
      _tempValid["tepdinhkemValidate"] &&
      _tempValid["tepdinhkemValidate"].some((error) => error)
    ) {
      setErrors(newValidationErrors);
      return;
    }
    if (
      _tempValid["tentepdinhkem"] &&
      _tempValid["tentepdinhkem"].some((error) => error)
    ) {
      setErrors(newValidationErrors);
      return;
    }

    if (
      _tempValid["tentepdinhkemEdit"] &&
      Object.values(_tempValid["tentepdinhkemEdit"])?.length > 0 &&
      Object.values(_tempValid["tentepdinhkemEdit"]).some((error) => error)
    ) {
      setErrors(newValidationErrors);
      return;
    }

    delete _tempValid["tentepdinhkem"];
    delete _tempValid["tepdinhkemValidate"];
    delete _tempValid["tentepdinhkemEdit"];
    delete _data["tepdinhkemValidate"];
    if (Object.values(_tempValid).some((error) => error)) {
      setErrors((prev) => ({
        ...prev,
        ...newValidationErrors,
      }));
      return;
    }
    let listName = [];
    fileFields?.forEach((item) => {
      if (!item?.remove) {
        listName.push(item?.filename);
      }
    });
    _data["tentepdinhkem"] = listName;
    _data["tepdinhkem"] = fileFields?.map((item) => item?.file) || [];
    // console.log(_data);
    onSubmit(_data);
  }

  const handelClear = () => {
    onClose();
  };

  useEffect(() => {
    if (validationErrors?.another) {
      setAlert({
        alert: true,
        message: validationErrors?.another,
        type: "error",
      });
    } else {
      setErrors(validationErrors);
    }
  }, [validationErrors]);

  useEffect(() => {
    if (open) {
      setErrors({});
      setValue(0);
      setFileDel([]);
      setFileFields([]);
      setFileEditName({});
    }
  }, [open]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleCloseAlert = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlert({ alert: false, message: null, type: null });
  };

  const handleChangeDataState = (data) => {
    let { name, value } = data;
    setDataState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleErrorDataState = (error) => {
    let { name, value } = error;
    setErrors((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  //change file
  const handleErrorDownload = (error) => {
    setAlert(error);
  };
  const handleOnDeleteFileDefault = (data) => {
    setFileDel(data);
  };
  const handleErrorFile = (error) => {
    setErrors(error);
  };
  const handleChangeFileList = (data) => {
    setFileFields(data);
  };
  const handleEditFileNameDefault = (data) => {
    setFileEditName(data);
  };
  return (
    <>
      {alert.alert && (
        <Snackbar
          autoHideDuration={3000}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          open={alert.alert}
          onClose={handleCloseAlert}
        >
          <Alert onClose={handleCloseAlert} severity={alert.type}>
            {alert.message}
          </Alert>
        </Snackbar>
      )}
      <Dialog
        fullScreen={fullScreen}
        open={open}
        PaperComponent={PaperComponent}
        onClose={handelClear}
        scroll="paper"
        PaperProps={{
          sx: {
            "@media (min-width: 768px)": {
              minWidth: "40rem",
            },
            height: "100%",
          },
        }}
      >
        {/* Form*/}
        <form
          ref={formRef}
          method="post"
          encType="multipart/form-data"
          style={{
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
            height: "100%",
          }}
        >
          {/* Tiêu đề modal - tham số title */}
          <DialogTitle sx={{ m: 0, p: 2, backgroundColor: "#ffffff" }}>
            {title ? title : "Chỉnh sửa sản phẩm"}
            <IconButton
              aria-label="close"
              onClick={handelClear}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <Box
            sx={{
              width: "100%",
              bgcolor: "background.paper",
              //borderBottom: 1,
              borderColor: "divider",
              padding: "0 1rem 1rem 1rem",
            }}
          >
            <Tabs
              value={value}
              onChange={handleChange}
              indicatorColor="secondary"
              textColor="primary"
              variant="fullWidth"
              aria-label="basic tabs example"
            >
              <Tab
                icon={<BusinessIcon />}
                label="Thông tin"
                {...JsonTool.a11yProps(0)}
              />
              <Tab
                icon={<ArticleIcon />}
                label="Tệp đính kèm"
                {...JsonTool.a11yProps(1)}
              />
            </Tabs>
          </Box>
          <DialogContent dividers sx={{ overflow: "auto", paddingTop: "0" }}>
            <Box>
              {/* show lỗi từ khi không xác định được từ các field ở form */}
              {errors && errors.error ? (
                <Grid container sx={{ textAlign: "center", mb: 0 }}>
                  <Grid item xs={12}>
                    <Alert severity="error" sx={{ mb: 3, mt: 0 }}>
                      {errors.error}
                    </Alert>
                  </Grid>
                </Grid>
              ) : (
                ""
              )}
              <CustomTabPanel value={value} index={0}>
                {fieldInfor?.length > 0 && (
                  <CustomFieldForm
                    key={"fieldInfor"}
                    listField={fieldInfor}
                    data={dataState}
                    onChange={handleChangeDataState}
                    onError={handleErrorDataState}
                    errorValues={errors}
                    listOptionDic={{
                      mahuyen: dataHuyen,
                      nhomsanpham: dataNhomSanPham,
                      chuthe: dataChuThe,
                      hang: [
                        {
                          id: 1,
                          ten: "1 sao",
                        },
                        {
                          id: 2,
                          ten: "2 sao",
                        },
                        {
                          id: 3,
                          ten: "3 sao",
                        },
                        {
                          id: 4,
                          ten: "4 sao",
                        },
                        {
                          id: 5,
                          ten: "5 sao",
                        },
                      ],
                      trangthaisanpham: [
                        {
                          id: 1,
                          ten: "Sản phẩm chưa công nhận",
                        },
                        {
                          id: 2,
                          ten: "Sản phẩm đang chờ đánh giá",
                        },
                        {
                          id: 3,
                          ten: "Sản phẩm đã công nhận",
                        },
                        {
                          id: 4,
                          ten: "Sản phẩm đã hết hạn",
                        },
                      ],
                    }}
                  />
                )}
              </CustomTabPanel>
              <CustomTabPanel value={value} index={1}>
                <AddListFile
                  dataDefault={data?.tepdinhkem_sanpham}
                  fileDel={fileDel}
                  fileEditName={fileEditName}
                  fileFields={fileFields}
                  errors={errors}
                  onDelete={handleOnDeleteFileDefault}
                  onError={handleErrorFile}
                  onFileChange={handleChangeFileList}
                  nameFile="sanpham"
                  onEditName={handleEditFileNameDefault}
                  onErrorDownload={handleErrorDownload}
                />
              </CustomTabPanel>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button
              color="secondary"
              type="button"
              variant="contained"
              startIcon={<Cancel />}
              size="small"
              onClick={handelClear}
              sx={{ color: "#ffffff", float: "right", mr: 1 }}
            >
              Hủy
            </Button>
            <Button
              type="submit"
              variant="contained"
              startIcon={<SaveIcon />}
              size="small"
              onClick={onSubmitForm}
              sx={{ color: "#ffffff", float: "right", mr: 1 }}
            >
              Lưu
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
};

const validateRequired = (value) => {
  let result = !!value?.length;
  if (typeof value == "number") {
    result = true;
  }
  return result;
};
const validateArrayRequired = (arrayValue) => {
  let result = [];
  if (arrayValue) {
    arrayValue.map((value, index) => {
      result.push("");
      if (!value?.length) result[index] = "Tên tệp không được trống";
    });
  }
  return result;
};

const validateFileEditName = (arrayValue) => {
  let result = {};
  if (arrayValue) {
    arrayValue.map((file, index) => {
      result[file?.id] = "";
      if (!file?.tentepdinhkem) result[file?.id] = "Tên tệp không được trống";
    });
  }
  return result;
};

function validateOBJ(hd, isOwner, dungluong) {
  let result = {
    ten: !validateRequired(hd.ten) ? "Tên sản phẩm không được trống" : "",
    hang: !validateRequired(hd.hang) ? "Chọn hạng sản phẩm" : "",
    trangthaisanpham: !validateRequired(hd.trangthaisanpham)
      ? "Chọn trạng thái sản phẩm"
      : "",
    nhomsanpham: !validateRequired(hd.nhomsanpham) ? "Chọn nhóm sản phẩm" : "",
    chuthe: !isOwner && !validateRequired(hd.chuthe) ? "Chọn chủ thể" : "",
    tentepdinhkem: validateArrayRequired(hd.tentepdinhkem),
    tepdinhkemValidate: validateArrayFileRequired(
      hd.tepdinhkemValidate,
      dungluong
    ),
    tentepdinhkemEdit: validateFileEditName(hd.tentepdinhkemEdit),
  };
  return result;
}
export default FormSanPham;
